import React from 'react';
import { Icon } from './Icon';

export interface CheckboxProps {
  checked?: boolean;
  onChange?: (checked: boolean) => void;
}

export function Checkbox({ checked, onChange }: CheckboxProps) {
  return (
    <button
      type="button"
      className={'checkbox' + (checked ? ' checked' : '')}
      onClick={() => onChange && onChange(!checked)}
    >
      {checked && <Icon name="check" size={13} strokeWidth={3} />}
    </button>
  );
}

export default Checkbox;
